import styled, { css } from 'styled-components';

import IconButton from '@polyai/ui/components/atoms/IconButton';
import { Body } from '@polyai/ui/components/atoms/LegacyText';
import { Stack } from '@polyai/ui/components/atoms/Stack';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const SubHeading = styled(Body)`
  margin-top: ${themeSpacing.sm1};
  margin-bottom: ${themeSpacing.sm4};
  color: ${themeColors.textSecondary};
`;

export const TwilioLink = styled.a`
  display: inline;
  font-weight: ${text.weight.semibold};
  color: ${themeColors.textSecondary};
`;

export const SmsNumberInputsSection = styled(Stack)`
  justify-content: space-between;
`;

export const DeleteButton = styled(IconButton)<{
  $isFirstRow?: boolean;
  $hasErrors?: boolean;
}>`
  margin-top: 0;

  ${({ $isFirstRow }) =>
    $isFirstRow &&
    css`
      margin-top: 14px;
    `}

  ${({ $hasErrors }) =>
    $hasErrors &&
    css`
      margin-bottom: 26px;
    `}
`;
export const SmsNumberInputWrapper = styled.div`
  flex: 1;
`;
